
jQuery(function() {
   
    if(jQuery('.swiper-box').length){
        var swiper = new Swiper(".swiper-box", {
            slidesPerView: "auto",
            spaceBetween: 15,
            pagination: {
            el: ".swiper-pagination",
            clickable: true,
            },
        });
    }
});